// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';

import { css } from '@emotion/css';
import { Theme, useTheme } from '@mui/material';

import { useTimeline } from '@components/Timeline/Timeline/TimelineProvider';

import TimelineIndexRow from '@components/Timeline/Timeline/TimelineIndexRow';

// COMPONENT ---------------------------------------------------------------- //

const TimelineIndexBody = () => {
  const theme = useTheme();
  const cls = useStyles(theme);

  const { data, zIndex } = useTimeline();

  if (!data?.length) return null;
  return (
    <div className={cls.timelineIndexBody} style={{ zIndex: zIndex + 6 }}>
      {data?.map((dataItem, i) => (
        <React.Fragment key={`timeline-index-row-${i}`}>
          <TimelineIndexRow dataItem={dataItem} index={i} isLastItem={i === data?.length - 1} />
        </React.Fragment>
      ))}
    </div>
  );
};

// STYLES --------------------------------------------------------------------- //

const useStyles = (theme: Theme) => ({
  timelineIndexBody: css`
    position: relative;
    flex: 1;
    width: 100%;
    background-color: ${theme.palette.background.paper};
    box-shadow: 0 0 16px #00000024;
  `,
});

// -------------------------------- EXPORT -------------------------------- //

export default TimelineIndexBody;
